/* Accessible cart drawer; standard product forms and cart page remain as fallbacks. */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const base = drawer.dataset.rootUrl.replace(/\/$/, '') + '/';
  const cartUrl = drawer.dataset.cartUrl;
  const itemsHost = drawer.querySelector('[data-cart-items]');
  const foot = drawer.querySelector('[data-cart-foot]');
  const status = drawer.querySelector('[data-cart-status]');
  const threshold = Number(drawer.dataset.threshold);
  let previousFocus = null;
  let busy = false;
  const format = cents => {
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active || 'ZAR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', {style:'currency',currency}).format(cents / 100); }
    catch (_) { return `R ${(cents / 100).toFixed(2)}`; }
  };
  const el = (tag, cls, value) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (value != null) node.textContent = value;
    return node;
  };
  const request = async (path, options) => {
    const res = await fetch(base + path, options);
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  const render = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = `(${cart.item_count})`);
    itemsHost.replaceChildren();
    foot.hidden = cart.item_count === 0;
    if (!cart.item_count) {
      itemsHost.append(el('p', 'rc-cart-drawer__empty', 'Your cart is ready for something useful.'));
      return;
    }
    cart.items.forEach((item, i) => {
      const row = el('article', 'rc-drawer-line');
      if (item.image) {
        const link = el('a'); link.href = item.url;
        const img = el('img'); img.src = item.image; img.alt = item.product_title; img.loading = 'lazy'; link.append(img); row.append(link);
      }
      const detail = el('div', 'rc-drawer-line__detail');
      const title = el('a', 'rc-drawer-line__title', item.product_title); title.href = item.url; detail.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') detail.append(el('small', null, item.variant_title));
      detail.append(el('strong', null, format(item.final_line_price)));
      const controls = el('div', 'rc-drawer-line__controls');
      const less = el('button', null, '−'); less.type = 'button'; less.dataset.cartLine = String(i + 1); less.dataset.quantity = String(item.quantity - 1); less.setAttribute('aria-label', `Decrease ${item.product_title} quantity`);
      const qty = el('span', null, String(item.quantity));
      const more = el('button', null, '+'); more.type = 'button'; more.dataset.cartLine = String(i + 1); more.dataset.quantity = String(item.quantity + 1); more.setAttribute('aria-label', `Increase ${item.product_title} quantity`);
      controls.append(less, qty, more); detail.append(controls); row.append(detail); itemsHost.append(row);
    });
    drawer.querySelector('[data-cart-subtotal]').textContent = format(cart.total_price);
    const remaining = Math.max(0, threshold - cart.total_price);
    drawer.querySelector('[data-shipping-message]').textContent = remaining ? `You're ${format(remaining)} away from free delivery.` : 'Your order qualifies for free delivery.';
    const meter = drawer.querySelector('[data-shipping-meter]');
    meter.setAttribute('aria-valuenow', String(Math.round(Math.min(cart.total_price, threshold) / 100)));
    drawer.querySelector('[data-shipping-fill]').style.width = `${Math.min(100, cart.total_price / threshold * 100)}%`;
  };
  const refresh = async () => render(await request('cart.js'));
  const open = async () => {
    previousFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('rc-drawer-open');
    drawer.querySelector('.rc-cart-drawer__panel').focus();
    status.textContent = 'Loading cart…';
    try { await refresh(); status.textContent = ''; }
    catch (_) { status.textContent = 'Unable to load the cart. Open the full cart page to continue.'; }
  };
  const close = () => {
    drawer.hidden = true;
    document.body.classList.remove('rc-drawer-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  };
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); open(); }
    if (e.target.closest('[data-cart-close]')) close();
  });
  drawer.addEventListener('keydown', e => {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled])')].filter(node => node.offsetParent !== null);
    if (!focusable.length) return;
    if (e.shiftKey && document.activeElement === focusable[0]) { e.preventDefault(); focusable.at(-1).focus(); }
    else if (!e.shiftKey && document.activeElement === focusable.at(-1)) { e.preventDefault(); focusable[0].focus(); }
  });
  drawer.addEventListener('click', async e => {
    const button = e.target.closest('[data-cart-line]');
    if (!button || busy) return;
    busy = true; status.textContent = 'Updating cart…';
    try {
      const cart = await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(button.dataset.cartLine),quantity:Number(button.dataset.quantity)})});
      render(cart); status.textContent = '';
      if (document.querySelector('.cart-page')) window.location.reload();
    } catch (error) { status.textContent = error.message; }
    finally { busy = false; }
  });
  document.querySelectorAll('[data-product-form],[data-mobile-product-form]').forEach(form => form.addEventListener('submit', async e => {
    if (busy) { e.preventDefault(); return; }
    const root = form.closest('[data-product-root]');
    if (!root || !form.querySelector('[name="id"]')?.value) return;
    e.preventDefault(); busy = true;
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    const error = root.querySelector('[data-product-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      await request('cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(form.querySelector('[name="id"]').value),quantity:Math.max(1,Number(form.querySelector('[name="quantity"]')?.value) || 1)})});
      await open();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
      else window.location.href = cartUrl;
    } finally {
      busy = false;
      if (button) button.disabled = !form.querySelector('[name="id"]')?.value;
      const visibleLabel = form.querySelector('[data-add-label],[data-sticky-add-label]');
      if (visibleLabel) visibleLabel.textContent = form.querySelector('[name="quantity"]')?.value === '2' ? 'Add 2 to cart' : 'Add to cart';
    }
  }));
  document.querySelectorAll('[data-mobile-product-form]').forEach(form => {
    const main = form.closest('[data-product-root]')?.querySelector('[data-product-form]');
    if (!main || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      form.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);
    }, {threshold:0});
    observer.observe(main);
  });
})();
